import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { QuillEditorComponent } from 'ngx-quill';

@Component({
    selector: 'formly-field-custom-quill',
    template: `<quill-editor [formControl]="formControl" class="border-0 p-0 mb-4" [formlyAttributes]="field">
    </quill-editor>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [QuillEditorComponent, FormsModule, ReactiveFormsModule, FormlyModule]
})
export class FieldQuillType extends FieldType<FieldTypeConfig> {
}

